module.exports = __webpack_public_path__ + "static/media/bronze-badge.0012f43c.svg";